import { createSelector } from 'reselect';
import { selectUser } from 'modules/App/utils/selectors';

const profileSelector = ({ profile }) => profile;
const relationsSelect = createSelector(profileSelector, ({ relations }) => relations);

export const selectUserRelationsList = createSelector(relationsSelect, (relations) =>
  relations.getIn(['list', 'data']),
);

export const selectUserRelationsListLoading = createSelector(relationsSelect, (relations) =>
  relations.getIn(['list', 'loading']),
);

export const selectRelationActionLoading = createSelector(relationsSelect, (relations) =>
  relations.getIn(['action', 'loading']),
);

export const selectActiveRelations = createSelector(relationsSelect, (relations) =>
  relations.getIn(['active', 'data']),
);

export const selectActiveRelationsIsLoading = createSelector(relationsSelect, (relations) =>
  relations.getIn(['active', 'loading']),
);

export const selectActiveRelationsError = createSelector(relationsSelect, (relations) =>
  relations.getIn(['active', 'error']),
);

export const selectHasRelations = createSelector(
  selectActiveRelations,
  (relations) => !relations.isEmpty(),
);

export const selectTaxpayersOptions = createSelector(
  [selectUser, selectActiveRelations],
  (user, relations) => [
    {
      label: user.getIn(['data', 'name']),
      value: user.getIn(['data', 'inn']),
    },
    ...relations.map((value) => ({
      label: value.get('fullName'),
      value: value.get('inn'),
    })),
  ],
);
